import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-stretch flex-shrink-0" }
const _hoisted_2 = { class: "btn btn-flex align-items-center bg-hover-white bg-hover-opacity-10 py-2 px-2 px-md-3" }
const _hoisted_3 = { class: "cursor-pointer symbol symbol-25px me-4" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "symbol-label bg-primary text-inverse-warning fw-bolder fs-7"
}
const _hoisted_6 = { class: "d-none d-md-flex flex-column align-items-start justify-content-center" }
const _hoisted_7 = { class: "text-white fs-4 fw-bolder lh-1" }
const _hoisted_8 = { class: "d-flex align-items-center ms-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-bell fs-1" }, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "position-absolute top-0 start-100 translate-middle badge badge-sm badge-circle badge-danger"
}
const _hoisted_11 = {
  class: "menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px",
  "data-kt-menu": "true",
  style: {"z-index":"105","position":"fixed","inset":"0px 0px auto auto","margin":"0px","transform":"translate3d(-229px, 65px, 0px)"},
  "data-testid": "toolbar notification button",
  "data-popper-placement": "bottom-end"
}
const _hoisted_12 = {
  class: "d-flex align-items-center mx-2",
  id: "kt_header_help_menu_toggle"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-circle-question fs-1" }, null, -1)
const _hoisted_14 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-white menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_15 = { class: "menu-item px-5" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "menu-icon",
  "data-kt-element": "icon"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-comment-smile" })
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title text-hover-white" }, "Leave Feedback", -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "menu-item px-5" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", {
  class: "menu-icon",
  "data-kt-element": "icon"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-gift" })
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title text-hover-white" }, "What's New", -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_24 = { class: "menu-item px-5" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", {
  class: "menu-icon",
  "data-kt-element": "icon"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-life-ring" })
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title text-hover-white" }, "Contact Support", -1)
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = {
  class: "d-flex align-items-center",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-cog fs-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_NotificationsMenu = _resolveComponent("NotificationsMenu")!
  const _component_UserMenu = _resolveComponent("UserMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args))),
      class: "d-none d-md-flex align-items-center ms-1"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.userStore.profile.avatar)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.userStore.profile.avatar,
                alt: "image"
              }, null, 8, _hoisted_4))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.userStore.profile.firstName[0]) + _toDisplayString(_ctx.userStore.profile.lastName[0]), 1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.userStore.profile.firstName), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_Button, {
        type: "",
        class: "btn btn-sm btn-icon btn-color-white bg-opacity-10 btn-active-color-primary position-relative",
        "data-kt-menu-trigger": "click",
        "data-kt-menu-attach": "parent",
        "data-kt-menu-placement": "bottom-end"
      }, {
        default: _withCtx(() => [
          _hoisted_9,
          (_ctx.unread > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.unread), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_NotificationsMenu)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_Button, {
        "data-testid": "toolbar help menu button",
        type: "",
        class: "btn btn-sm btn-icon btn-color-white bg-opacity-10 btn-active-color-primary position-relative",
        "data-kt-menu-trigger": "click",
        "data-kt-menu-attach": "parent",
        "data-kt-menu-placement": "bottom-end"
      }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.invokeFeedbackModal && _ctx.invokeFeedbackModal(...args))),
            class: "menu-link text-white px-3"
          }, _hoisted_18)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showReleaseNotes && _ctx.showReleaseNotes(...args))),
            class: "menu-link text-white px-3"
          }, _hoisted_22)
        ]),
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showSupportChatWidget && _ctx.showSupportChatWidget(...args))),
            class: "menu-link text-white px-3"
          }, _hoisted_27)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createVNode(_component_Button, {
        "data-testid": "toolbar settings button",
        type: "",
        class: "btn btn-sm btn-icon btn-color-white bg-opacity-10 btn-active-color-primary position-relative",
        "data-kt-menu-trigger": "click",
        "data-kt-menu-attach": "parent",
        "data-kt-menu-placement": "bottom-end"
      }, {
        default: _withCtx(() => [
          _hoisted_29
        ]),
        _: 1
      }),
      _createVNode(_component_UserMenu)
    ])
  ]))
}